/**
 * Vue Filter - pluralize
 */

/**
 * Convery number to pluralize string.
 * @param {number} val Number
 * @param {boolean} usePref Use prefix.
 */
export default function pluralize(val = 0, suffix) {
	return val == 1 ? `${val} ${suffix}` : `${val} ${suffix}s`
}
